import { Colors, Services } from '@sigma-frontend-libs/commons'

import { components, getLocaleDateString, getLocaleTimeString, icons, sizes, states } from '@/utils'

import squircle from '@/components/icon/squircle'
import versionNotification from '@/components/misc/version/notification'
import preloader from '@/components/preloader'
import { getColor } from '@/components/services/notifications/utils'
import tag from '@/components/tag'

function renderArrow(h, direction) {
  let icon = icons.keyboard_arrow_down
  if (direction === 'top') {
    icon = icons.keyboard_arrow_up
  }

  return h(
    'div',
    {
      class: {
        [`${Services.notifications}-widget__arrow`]: true,
        [`${Services.notifications}-widget__arrow--${direction}`]: this.arrow[direction]
      },
      on: {
        click: () => {
          this.scroll(direction)
        }
      }
    },
    [
      h(
        components.icon,
        {
          props: {
            value: icon,
            color: Colors.grey,
            size: 16
          }
        }
      )
    ]
  )
}

function renderHeaderContent(h) {
  return h(
    'div',
    {
      class: `${Services.notifications}-widget__header-content`
    },
    [
      h(
        'div',
        {
          class: `${Services.notifications}-widget__header-title`
        },
        [ this.getTranslate(`${Services.notifications}.title`) ]
      ),
      h(
        'div',
        {
          class: `${Services.notifications}-widget__header-text`
        },
        [ this.getTranslate(`${Services.notifications}.description`) ]
      )
    ]
  )
}
function renderHeader(h) {
  return h(
    'div',
    {
      class: `${Services.notifications}-widget__header`
    },
    [
      h(
        squircle,
        {
          props: {
            iconSVG: Services.notifications,
            iconSize: 28,
            size: sizes.medium,
            color: Colors.white
          }
        }
      ),

      renderHeaderContent.call(this, h)
    ]
  )
}

function renderVersionNotification(h) {
  return h(versionNotification)
}

function renderContent(h, item) {
  const { title, text } = item

  return h(
    'div',
    {
      class: `${Services.notifications}-widget__notification-content`
    },
    [
      h(
        'div',
        {
          class: `${Services.notifications}-widget__notification-content__title`
        },
        [ title ]
      ),

      h(
        'div',
        {
          class: `${Services.notifications}-widget__notification-content__text`,
          domProps: {
            innerHTML: text.replace(/\n/g, '<br />')
          }
        }
      )
    ]
  )
}
function renderType(h, type) {
  return h(
    tag,
    {
      props: {
        label: this.getTranslate(`${Services.notifications}.events.${type}`),
        color: getColor(type),
        size: sizes.small
      }
    }
  )
}
function renderDate(h, isRead, createdAt, id) {
  let dateIconColorName = Colors.grey
  if (isRead) {
    dateIconColorName = Colors.success
  }

  let dateIcon = icons.done
  if (this.loading[id]) {
    dateIcon = icons.more_horiz
  } else if (isRead) {
    dateIcon = icons.done_all
  }

  let dateIconColor = Colors.grey
  if (this.loading[id]) {
    dateIconColor = Colors.primary
  } else if (isRead) {
    dateIconColor = Colors.success
  }

  return h(
    'div',
    {
      class: `${Services.notifications}-widget__notification-date`
    },
    [
      h(
        tag,
        {
          props: {
            label: [ getLocaleDateString(createdAt), getLocaleTimeString(createdAt) ].join(' '),
            size: sizes.small
          }
        }
      ),

      h(
        'div',
        {
          class: {
            [`${Services.notifications}-widget__notification-date-icon`]: true,
            [`${Services.notifications}-widget__notification-date-icon--${dateIconColorName}`]: true
          }
        },
        [
          h(
            components.icon,
            {
              props: {
                value: dateIcon,
                color: dateIconColor,
                size: 14
              }
            }
          )
        ]
      )
    ]
  )
}
function renderInfo(h, item) {
  const { id, type, isRead, createdAt } = item

  return h(
    'div',
    {
      class: `${Services.notifications}-widget__notification-info`
    },
    [
      renderType.call(this, h, type),
      renderDate.call(this, h, isRead, createdAt, id)
    ]
  )
}
function renderItem(h, item) {
  const { id, type } = item

  return h(
    'div',
    {
      attrs: { id },
      class: {
        [`${Services.notifications}-widget__notification`]: true,
        [`${Services.notifications}-widget__notification--${getColor(type)}`]: true
      }
    },
    [
      renderContent.call(this, h, item),
      renderInfo.call(this, h, item)
    ]
  )
}
function renderItems(h) {
  return this.restData[Services.notifications].find.data.map(item => {
    return renderItem.call(this, h, item)
  })
}
function renderList(h) {
  return h(
    'div',
    {
      class: `${Services.notifications}-widget__list`,
      ref: 'list'
    },
    [ renderItems.call(this, h) ]
  )
}
function renderViewport(h) {
  return h(
    'div',
    {
      class: `${Services.notifications}-widget__viewport`,
      ref: 'viewport',
      on: {
        wheel: () => {
          return this.wheelHandler()
        },
        scroll: () => {
          return this.scrollHandler()
        }
      }
    },
    [ renderList.call(this, h) ]
  )
}
function renderBody(h) {
  const { data, state } = this.restData[Services.notifications].find
  switch (state) {
    case states.ready: {
      if (Array.isArray(data) && data.length) {
        return h(
          'div',
          {
            class: `${Services.notifications}-widget__body`
          },
          [
            renderArrow.call(this, h, 'top'),
            renderViewport.call(this, h),
            renderArrow.call(this, h, 'bottom')
          ]
        )
      } else {
        return h(components.empty)
      }
    }
    case states.loading: return h(preloader)
    default: return h(components.empty)
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: `${Services.notifications}-widget`
    },
    [
      renderHeader.call(this, h),
      renderVersionNotification.call(this, h),
      renderBody.call(this, h)
    ]
  )
}
